import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';

export const useAxiosWithAuth = () => {
  const { getAccessTokenSilently } = useAuth0();

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  axiosInstance.interceptors.request.use(
    async (config) => {
      try {
        const token = await getAccessTokenSilently();
        if (token) {
          config.headers.set('Authorization', `Bearer ${token}`);
        }
      } catch (error) {
        console.error('Error fetching access token:', error);
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  return axiosInstance;
};